import { useLookerSdk } from '@/hooks/useLookerSdk';

import { query } from '../utils/query';

const inMemoryCache = new Map<string, string>();

export function useGetPlatformApiKey() {
  const coreSDK = useLookerSdk();

  return async function getPlatformApiKey(model: string): Promise<string> {
    const inMemoryApiKey = inMemoryCache.get(model);

    if (inMemoryApiKey) {
      return inMemoryApiKey;
    }

    const [platformApiKey] = await query(coreSDK)
      .from<{
        'platform_api_key.api_token': string;
      }>({
        model,
        view: 'platform_api_key',
        fields: ['platform_api_key.api_token'],
        limit: '1',
      })
      .toMany<string>(
        (result) => result['platform_api_key.api_token'] ?? undefined,
      );

    if (platformApiKey) {
      inMemoryCache.set(model, platformApiKey);
    }

    return platformApiKey ?? '';
  };
}
